import { color } from "@ui";

const measuredColor = color.raw.lightNitrogen600;
const expectedColor = color.raw.chlorine600;
const symptomColor = color.raw.lightNitrogen100;
const fadedSymptomColor = color.raw.lightNitrogen100Fade050;
const unexplainedSymptomColor = color.raw.carbon600;
const fadedUnexplainedSymptomColor = color.raw.carbon600Fade050;
const confidenceAreaColor = color.raw.chlorine100;
const fadedConfidenceAreaColor = color.raw.chlorine100;
const sparklineAreaColor = color.raw.chart_categorical_blue;
const fadeSparklineAreaColor = color.raw.chart_fade_categorical_blue;
const sparklineMarkerColor = color.raw.lightNitrogen900;

const seriesColors = {
  measured: measuredColor,
  expected: expectedColor,
  symptom: symptomColor,
  fadedSymptom: fadedSymptomColor,
  unexplainedSymptom: unexplainedSymptomColor,
  fadedUnexplainedSymptom: fadedUnexplainedSymptomColor,
  confidenceArea: confidenceAreaColor,
  fadedConfidenceArea: fadedConfidenceAreaColor,
  sparklineArea: sparklineAreaColor,
  fadeSparklineArea: fadeSparklineAreaColor,
  sparklineMarker: sparklineMarkerColor,
};

export default seriesColors;
